@if(!hideCard()){
<div class="white-box">
	<div class="header">
		<h4 class="d-flex justify-content-between align-items-center">
			{{header()}}
			@if(closeable()){
			<button class="btn btn-flat p-0" (click)="close()">
				<i class="fa fa-times" aria-hidden="true"></i>
			</button>
			}
		</h4>
	</div>
	<div class="body">
		<ng-content></ng-content>
	</div>
</div>
}